import React from 'react';
import { pdf, Font, Document, Page, Text, Image,View, StyleSheet } from '@react-pdf/renderer';
import cl from './Invoice.module.css'
import Attachment from "../../../../assets/Icon/Attachment"; 
import PDFicon from "../../../../assets/Icon/FileDollar";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaMd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-65Md.ttf';
import { displayName } from 'react-quill';
import { useTranslation } from 'react-i18next';
import { baseFileURL } from '../../../../Api';
import AutomobyLogo from '../../../../assets/Logo/Automoby.png';
import AigLogo from '../../../../assets/Logo/Aig.png';
import AutonomoLogo from '../../../../assets/Logo/autonomo.png';

const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};

let CompanyName = ""
let CompanyNameGeo = ""
let CompanyId = ""
let CompanyAddress = ""
let CompanyPhone = ""
let primaryColor = "#000"
let BankName1 = ""
let BankSwift1 = ""
let Iban1 = ""
let BankName2 = ""
let BankSwift2 = ""
let Iban2 = ""
let Description = ""
let Description2 = ""

if(baseFileURL === 'https://finance.automoby.ge') {

    CompanyName = "LLC Automoby" 
    CompanyNameGeo = "შპს ავტომობის" 
    CompanyId = "446977022" 
    CompanyAddress = "D. Agmashenebeli st. #154, Tbilisi, Georgia" 
    CompanyPhone = "(+995) 591 24 60 60; 0322 11 55 22" 
    primaryColor = "#235e82" 
    BankName1 = "Bank of Georgia"
    BankSwift1 = "BAGAGE22"
    Iban1 = "<Text>GE74BG0000000533900476 GEL/USD</Text>"
    BankName2 = ""
    BankSwift2 = ""
    Iban2 = "" 
    Description = "<Text>*დანიშნულებაში მიუთითეთ ავტოსატრანსპორტო საშუალების VIN კოდი სრულად</Text>" 
    Description2 = "<Text>*ტრანსპორტირების თანხის გადახდა ხორციელდება ლარში, გადახდის დღეს არსებული ეროვნული ბანკის კურსით</Text>" 

} else if(baseFileURL === 'https://crm.aig.com.ge' ||  baseFileURL === 'https://crmdev.aig.com.ge' ) {

    CompanyName = "LLC Auto Import Georgia " 
    CompanyNameGeo = "შპს ავტო იმპორტ ჯორჯიას" 
    CompanyId = "406203120" 
    CompanyAddress = "2nd Lane of Giorgi Saakadze \nAtrium Business Center 1st Floor \nTbilisi, 0160, Georgia" 
    CompanyPhone = "(+995) 591 24 60 60; 0322 11 12 13" 
    primaryColor = "#da0429" 
    BankName1 = "Bank of Georgia"
    BankSwift1 = "BAGAGE22"
    Iban1 = "<Text>GE19BG0000000131217994 GEL/USD</Text>"
    BankName2 = "JSC TBC BANK"
    BankSwift2 = "TBCBGE22"
    Iban2 = "GE54TB7734536020100004 GEL" 
    Description = "<Text>*დანიშნულებაში მიუთითეთ ავტოსატრანსპორტო საშუალების VIN კოდი სრულად</Text>" 
    Description2 = "<Text>*ტრანსპორტირების თანხის გადახდა ხორციელდება ლარში, გადახდის დღეს არსებული ეროვნული ბანკის კურსით</Text>" 

} else if(baseFileURL === 'https://crm.autonomo.kz'  ) {
    CompanyName = "Autonomo" 
    CompanyId = "250640003889" 
    CompanyAddress = "130 Abay Avenue, Apt. 219, Postal Code 050060" 
    CompanyPhone = "+77770104242" 
    primaryColor = "#002cdf" 
    BankName1 = "JSC 'Bank CenterCredit'"
    BankSwift1 = "KCJBKZKX"
    Iban1 = "<Text>KZ678562203146557136KZT </Text>  <Text>KZ928562203246557284USD </Text>"
    BankName2 = ""
    BankSwift2 = ""
    Iban2 = "" 
    Description = "<Text>*ADD 6 DIGS OF VIN CODE IN SUBJECT</Text>" 
    Description2 = "" 

}

Font.register({
    family: 'HelveticaMd',  
    src: HelveticaMd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaMd', 
        backgroundColor: '#FFF',
        padding: 0,
    },

    header: {
        width: '90%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '50px',
        borderBottom: '4px solid '+ primaryColor,
        marginLeft:'30px'

    },

    invoiceBox: {
        color: '#fff',
        padding: '10px 10px 10px 0px',
    },

    invoiceText: {
        color: '#fff',
        fontSize: '22px',
        fontFamily: 'HelveticaBold',
    },

    invoiceDateAndId: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },

    invoiceDate: {
        marginBottom: '2px',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceDateText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold', 
    },

    invoiceDateIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceNumber: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceNumberText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold',
    },

    invoiceNumberIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceToCompany: {
        marginTop: '40px',
        padding: '0 30px',
    },

    invoiceToCompanyBG: {
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        backgroundColor: '#eaeaea',
        padding: '20px 20px',
        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)'
 
    },

    invoiceTo: {
        width: '50%',
        borderRight: '2px solid '+ primaryColor,
    },
    invoiceCompany: {
        width: '50%',
        paddingLeft: '40px',
    },

    invoiceToHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
        fontWeight: 'bold'
    },

    invoiceCompanyHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
    },

    invoiceToName: { 
        fontSize: '12px',
        color: '#000',
        marginBottom: '6px',
    },

    invoiceCompanyName: { 
        fontSize: '13px',
        color: '#000',
        marginBottom: '6px',
    },




    invoiceParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
        marginBottom: '1px',
    },

    invoiceParamText: {
        width: '25px',
        maxWidth: '25px',
        minWidth: '25px',
        color: '#000',
        fontSize: '12px', 
    },

    invoiceParamValue: {
        fontSize: '12px',
        color: '#666',
    },


    
    tableBox: { 
        padding: '0 30px',
        marginTop: '30px',
    }, 
    
    table: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRow: {   
        flexDirection: "row",  
    }, 

    tableCol: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        backgroundColor: '#30343b',
        color: '#fff',
        padding: '10px',
        fontSize: 15,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center'  
    },  
    tableCell: { 
        lineHeight: .9,
        margin: "0", 
        fontFamily: 'HelveticaBold' 
    },
     
 
    
    tableBoxResult: { 
        padding: '0 30px',
        marginTop: '10px',
    }, 
    
    tableResult: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRowResult: {   
        flexDirection: "row",  
    }, 

    tableColResult: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        border: '1px solid black',
        color: '#000',
        padding: '10px',
        fontSize: 14,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center', 
        family: 'HelveticaBold', 
    }, 

    tableCellResult: { 
        lineHeight: .9,
        margin: "0",  
    },

    bankParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '4px',
    },

    bankParamText: {
        fontFamily: 'HelveticaBold',
        width: '60px',
        color: '#000',
        fontSize: '10px', 
    },

    bankParamValue: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: 'flex-end', 
        fontSize: '10px',
        color: '#555',
    },
});



 const extractText = (input) => {
  const regex = /<Text>(.*?)<\/Text>/g;
  let match;
  const results = [];
  while ((match = regex.exec(input)) !== null) {
    results.push(match[1]);
  }
  return results;
};



const MyDocument = ({  invoiceData, discountAccept, clientData, websiteData }) => (
    <Document>

        <Page size="A4" style={styles.page}>

            <View style={styles.header}>

                <View style={styles.invoiceBox}>
 

                        {baseFileURL === 'https://finance.automoby.ge' ? (
                            <Image src={AutomobyLogo} style={{height: '30px',width: '113.5px'}} />
                        ) : baseFileURL === 'https://crm.aig.com.ge' ||  baseFileURL === 'https://crmdev.aig.com.ge' ? (
                            <Image src={AigLogo} style={{height: 'auto',width: '113.5px'}} />
                        ) : baseFileURL === 'https://crm.autonomo.kz' ? (
                            <Image src={AutonomoLogo} style={{height: 'auto',width: '113.5px'}} />
                        ) : null}

                </View>

                <View style={styles.invoiceDateAndId}>
                    <View style={styles.invoiceNumber}>
                        <Text style={styles.invoiceNumberText}>Invoice:</Text>
                        <Text style={styles.invoiceNumberIDText}>{invoiceData.id}{invoiceData.lot !== undefined ? '/' + invoiceData.lot : ''}</Text>
                    </View>
                    <View style={styles.invoiceDate}> 
                        <Text style={styles.invoiceDateText}>Date:</Text>
                        <Text style={styles.invoiceDateIDText}>{formatDate(invoiceData.purchased_at)}</Text>
                    </View>
                </View>
            </View>

            <View style={styles.invoiceToCompany}>
                <View style={styles.invoiceToCompanyBG}>

                    <View style={styles.invoiceTo}>
                        <Text style={styles.invoiceToHeader}>Client:</Text>
                        <Text style={styles.invoiceToName}>{clientData.firstname} {clientData.lastname}</Text>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>ID:</Text>
                            <Text style={styles.invoiceParamValue}>{ clientData.personal }</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ph:</Text>
                            <Text style={styles.invoiceParamValue}>{ clientData.mobile }</Text>
                        </View>
                    
                    </View>

 

                    <View style={styles.invoiceCompany}>

                        <Text style={styles.invoiceCompanyHeader}>Company:</Text>
                        <Text style={styles.invoiceCompanyName}>{CompanyName}</Text>
                    
                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>ID:</Text>
                            <Text style={styles.invoiceParamValue}>{CompanyId}</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ad:</Text>
                            <Text style={styles.invoiceParamValue}>{CompanyAddress}</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ph:</Text>
                            <Text style={styles.invoiceParamValue}>{CompanyPhone}</Text>
                        </View>

                    </View>
                </View>
            </View>


    
            {websiteData.id === 5 ? 
                <></>
            
            : 

                <> 
                    <View style={styles.tableBox}> 
                        <View style={styles.table}>  
                        
                            <View style={styles.tableRow}> 
                                <View style={{ ...styles.tableCol, width: '35%' }}> 
                                    <Text style={styles.tableCell}>Make/Model/Year</Text> 
                                </View> 
                                <View style={{ ...styles.tableCol, width: '23%' }}> 
                                    <Text style={styles.tableCell}>Car Price</Text> 
                                </View> 
                                <View style={{ ...styles.tableCol, width: '25%' }}> 
                                    <Text style={styles.tableCell}>Transportation</Text> 
                                </View> 
                                <View style={{ ...styles.tableCol, width: '17%' }}>
                                    <Text style={styles.tableCell}>Other fee</Text> 
                                </View>
                                
                            </View>
        
                        </View>
                    </View>
        
                    <View style={styles.tableBoxResult}> 
                        <View style={styles.tableResult}>  

                            <View style={styles.tableRowResult}> 
                                <View style={{ ...styles.tableColResult, width: '35%' }}> 
                                    <Text style={{...styles.tableCellResult, fontSize: 10 }}>{invoiceData.prod_year && invoiceData.prod_year} {invoiceData.maker && invoiceData.maker.name} {invoiceData.model && invoiceData.model.name}</Text> 
                                    <Text style={{...styles.tableCellResult, marginTop: '5px', fontSize: 10, }}>{invoiceData.vin}</Text> 
                                </View> 
                                <View style={{ ...styles.tableColResult, width: '23%' }}> 
                                    <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                        {  
                                            invoiceData.client_price_car+
                                            invoiceData.client_price_document +
                                            invoiceData.client_price_insurance +
                                            invoiceData.client_price_penalty +
                                            invoiceData.client_price_transfer_fee +
                                            invoiceData.client_price_another +
                                            invoiceData.client_price_inspection  +
                                            invoiceData.client_price_internal +
                                            invoiceData.client_price_dealer  
                                         }
                                        $
                                    </Text> 
                                </View> 
                                <View style={{ ...styles.tableColResult, width: '25%' }}>                                 
                                    <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                        { 
                                            invoiceData.client_price_transport+
                                            invoiceData.client_price_dealer_transport 
                                        }$</Text>
                                </View> 
                                <View style={{ ...styles.tableColResult, width: '17%' }}> 
                                    <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                    {
                                        (invoiceData.client_real_percent !== 0 ? invoiceData.client_real_percent : 0)  
                                    }$
                                    </Text> 
                                </View> 
                            
                            </View>
        
                        </View>
                    </View> 
                </>  

            }
  
            {discountAccept == 1 && (
                <View style={{ 
                    fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '14px', padding: '10px 0px', marginBottom: '0px', marginLeft: 'auto', marginRight: '30px', color: primaryColor, borderBottom:'3px solid '+ primaryColor }}> 
                    <Text style={{ marginTop: '0px',}}> 
                        Discount: -{ invoiceData.client_price_discount } USD
                    </Text> 
                </View>
            )}
             

            <View style={{ 
        fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '14px', padding: '0', marginBottom: '20px', marginTop:'10px', marginLeft: 'auto', marginRight: '30px' }}> 
                <Text style={{ marginTop: '0px',}}>
                  {(websiteData.id === 5 ? 'DEPOSIT' :  'TOTAL'  ) } : { invoiceData.total_client_price } USD  
                </Text> 
            </View>  

            <View style={{ 
        fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '14px', padding: '10px 20px', border:'3px solid '+ primaryColor,marginBottom: '50px',marginLeft: 'auto', marginRight: '30px' }}> 
                <Text style={{ marginTop: '0px',}}> 
                        Debit: {(websiteData.id === 5 ? 
                                    invoiceData.client_deposit 
                                :  
                                    invoiceData.client_debt  ) } USD
                </Text> 
            </View>  

            



            <View style={{display: 'flex',flexDirection: "row", justifyContent: 'space-between', border: '2px solid '+ primaryColor, margin: '0 30px', padding:'10px', marginBottom: '20px'}}>
                <View>
                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Name</Text>
                        <Text style={styles.bankParamValue}>{BankName1}</Text>
                    </View>


                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Swift</Text>
                        <Text style={styles.bankParamValue}>{BankSwift1}</Text>
                    </View>

                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>IBAN</Text>
                        <Text style={styles.bankParamValue}>{extractText(Iban1)}</Text>
                    </View>
                </View>

                {BankName2.length > 2 && (
                
                    <View>
                        <View style={styles.bankParam}>
                            <Text style={styles.bankParamText}>Bank Name</Text>
                            <Text style={styles.bankParamValue}>{BankName2}</Text>
                        </View>


                        <View style={styles.bankParam}>
                            <Text style={styles.bankParamText}>Bank Swift</Text>
                            <Text style={styles.bankParamValue}>{BankSwift2}</Text>
                        </View>

                        <View style={styles.bankParam}>
                            <Text style={styles.bankParamText}>IBAN</Text>
                            <Text style={styles.bankParamValue}>{Iban2}</Text>
                        </View>
                    </View>
    
                )}
            </View>



            {websiteData.id === 5 ? 
                <>
                     <View style={{border: '2px solid '+primaryColor, margin: '0 30px', padding:'10px', fontSize: '10px'}}>
                        <Text>*დანიშნულებაში მიუთითეთ: “დეპოზიტი - ინვოისის ნომერი”</Text>
                        <Text>*თანხის გადახდა ხორციელდება ლარში, გადახდის დღეს არსებული ეროვნული ბანკის კურსით </Text>
                    </View>

                    <View style={{border: '2px solid '+primaryColor, margin: '20px 30px', padding:'10px', fontSize: '10px'}}>
                        <Text> *მომხმარებელი {CompanyNameGeo} საბანკო ანგარიშზე რიცხავს უსაფრთხოების დეპოზიტს უცხოურ საავტომობილო აუქციონში ან პლატფორმაზე ავტომობილის შერჩევის, შემოწმებისა და/ან შეძენის მიზნით;</Text>
                        <Text style={{ margin: '10px 0'}}> *ავტომობილის აუქციონზე მოგების და მომხმარებლის მიერ ავტომობილის შეძენაზე უარის შემთხვევაში, უსაფრთხოების დეპოზიტი დაბრუნებას არ ექვემდებარება და გამოიყენება წარმოშობილი ხარჯებისა და ჯარიმების დასაფარად;  </Text>
                        <Text> *იმ შემთხვევაში, თუ შერჩეული ავტომობილის შეძენა ვერ განხორციელდება, მომხმარებელი უფლებამოსილია უსაფრთხოების დეპოზიტი გამოიყენოს სხვა ავტომობილის შესაძენად ან მოითხოვოს მისი დაბრუნება, რაც განხორციელდება არაუგვიანეს 1 სამუშაო დღის ვადაში.  </Text>
                    </View> 
 
                </>
            
            : 

                <> 
                 
            
                    <View style={{border: '2px solid '+primaryColor, margin: '0 30px', padding:'10px', fontSize: '10px'}}>
                        <Text>{extractText(Description)} </Text>
                        <Text>{extractText(Description2)} </Text>
                    </View>
                </>  

            }
 
             
        </Page>


    </Document>
);

const AutowiniInvoice = ({ greenStyle, secondBtn, carItem, discountAccept, clientItem, websiteItem}) => {
      const {t} = useTranslation();
  
    const generatePDF = async () => {
      
        const blob = await pdf(<MyDocument invoiceData={carItem} discountAccept={discountAccept} clientData={clientItem} websiteData={websiteItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'invoice.pdf';
        link.click();
    };

        if (secondBtn) {
            return ( <span 
                        className={`${cl.invoiceLink} ${greenStyle ? cl.greenStyle : ''}`}
                        onClick={generatePDF}> <Attachment /> </span> );
        } else {
            return (  <span 
                        className={`${cl.btn} ${greenStyle ? cl.greenStyle : ''}`}
                        onClick={generatePDF}> <PDFicon /> {t('Invoice')} </span> );

        }
 
};

export default AutowiniInvoice;
